import { iUser } from './../../../models/user.model';
import { BookService } from './../../../services/book.service'; 
import { Component, Input, OnInit } from '@angular/core';
import { description } from 'src/app/models/books.model';
import * as moment from 'moment';
import { ENGINE_METHOD_CIPHERS } from 'constants';

@Component({
  selector: 'generate-report',
  templateUrl: './generate-report.component.html',
  styleUrls: ['./generate-report.component.scss']
})
export class GenerateReportComponent implements OnInit {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() icon = 'receipt';
  @Input() type = '';
  @Input() user:iUser;
  public anni = [];
  public mesi = [];
  public editori = [];
  public selected = {
    mese : null,
    anno : null,
    editore : null
  }

  public loader = {
    editore : false,
    anno : false,
    mese : false
  };

  constructor(private  bookservice: BookService) { }

  ngOnInit(): void {
    if (this.user.isAdmin()) {
      this.getEditoriList();
    } else {
      this.loader.editore = false;
      this.selected.editore = this.user.code;
      this.getAnniList();
    }
     
  }

 async getEditoriList() { 
   this.loader.editore = true;
      this.bookservice.editoriReport().subscribe((data: Array<description>) =>{
          this.editori = data;
          this.loader.editore= false;
      }),
      (error)=> {
          console.log(error);
      }
  }

  public getAnniList() {
    this.loader.anno = true;
    this.bookservice.anniReport(this.selected.editore).subscribe((data:any) => { 
      this.loader.anno = false;
      this.anni = data;
    });

  }

  public getMesiList() {
    this.loader.mese = true;
    this.bookservice.mesiReport(this.selected.editore, this.selected.anno).subscribe((data:any) => {
      this.loader.mese = false;
      this.mesi = data;
    });
  }

  public printMonth(mese : number):string {
    moment.locale('it');
    const m =  moment(new Date());
    m.set({ 'month': mese-1});
    return m.format("MMMM");
  }

  public scaricaRendiconto() {
        this.bookservice
        .downloadReport(this.selected.editore, this.selected.anno, this.selected.mese)
        .subscribe((responseData:any) => {
          const blob = new Blob([responseData], {type: 'application/pdf'}); 
          const a = document.createElement('a');
          a.href = URL.createObjectURL(blob); 
        //  a.click();
          const myWindow = window.open( a.href, "My Window");
      
        }); 
  }
}
